import { SaleableCategoryModel, ServiceModel } from "types/generated/models";
import { selectBooking, useClientPortalSelector } from "../../../redux";
import { useGetQuery } from "../../../hooks/useClientPortalQuery";
import { useAppointmentBookingApi } from "../../../hooks/useAppointmentBookingApi";

export interface ServicesResponse {
    services: ServiceModel[];
    saleableCategories: SaleableCategoryModel[];
}

export interface IServicesHook {
    services?: ServiceModel[] | null;
    saleableCategories?: SaleableCategoryModel[] | null;
    isLoading: boolean;
}

export function useServices(): IServicesHook {
    const { getEndpoint } = useAppointmentBookingApi();
    const { location } = useClientPortalSelector(selectBooking);

    const locationId = location.data?.locationId;

    const { data, isLoading } = useGetQuery<ServicesResponse>({
        url: `${getEndpoint("GetServices")}?locationId=${locationId}`,
    });

    return {
        services: data?.services,
        saleableCategories: data?.saleableCategories,
        isLoading,
    };
}
